module.exports = __webpack_public_path__ + "static/media/icon-arrow.5f732fd5.svg";